module.exports = __webpack_public_path__ + "img/icon_service_3x.db933f5f.png";